<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <img v-on="on"
        class="ma-1" width="24"
        :src="src"
      />
    </template>
    <span>{{ skill }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ['skill'],
  computed: {
    src() {
      let root = '/img/icons';
      return `${root}/${this.skill.toLowerCase()}.svg`;
    }
  }
};
</script>
